import { mapGetters, mapMutations } from 'vuex'
import { getProductPriceTitle, resolveProductImage, routeToProduct } from '@/helpers'

export default {
  name: 'default-price',
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedCount: 1,
    }
  },
  computed: {
    ...mapGetters({
      basket: 'basket/basket',
      productsPdf: 'order/productsPdf',
      currentRegionCurrency: 'regions/currentRegionCurrency',
    }),
  },
  methods: {
    getProductPriceTitle,
    routeToProduct,
    resolveProductImage,
    ...mapMutations({
      setCount: 'basket/SET_POSITION_COUNT',
      remove: 'basket/REMOVE_ITEM_FROM_BASKET',
    }),
    isSample(product) {
      return product.type === 'sampler'
    },
    allowedProductManipulations(product) {
      return !product.isAddedFromSale && !this.isSample(product) && !product.isPresent
    },
    changeCount(type, count = 1) {
      // `product` is a display row, so its count is the whole position — the
      // paid units plus the one a promotion may have discounted to 0.01.
      let nextCount = this.product.select_count

      if (type === 'increment') {
        nextCount = this.product.select_count + 1
      } else if (type === 'decrement') {
        nextCount = this.product.select_count - 1
      } else {
        if (!count) return
        nextCount = parseInt(count)
      }

      if (!nextCount || nextCount < 1) return

      this.setCount({
        product: this.product,
        select_count: nextCount,
      })
    },
    findProductInBasket(id) {
      return this.basket.find((product) => product.id === id)
    },
    isSample(product) {
      const productInBasket = this.findProductInBasket(product.id)
      const isSampler = productInBasket.type === 'sampler'
      const isFreePrice = productInBasket.allProductSum / productInBasket.select_count === 0.01
      return isSampler && isFreePrice && product.select_type.clientPrice
    },
  },
}
